<template>
  <PTCLink
    :to="url"
    :target="openInNewTab ? '_blank' : '_self'"
    external
    @click="handleClick"
  >
    <slot />
  </PTCLink>
</template>
<script setup lang="ts">
import type { ExternalLink } from '~/sanity/types';
const props = defineProps<ExternalLink>();
const url = props.url;

// handle internal anchor links with # to scroll to section
const handleClick = (event: MouseEvent) => {
  if (typeof url === 'string' && url.startsWith('#')) {
    const hash = url.split('#')[1];
    if (hash) {
      event.preventDefault();
      scrollToSection(hash);
    }
  }
};
</script>

<style lang="scss" scoped></style>
